// extracted by mini-css-extract-plugin
export default {"base--default":"SSHException_base--default__26HTR","subtitle2--invalid":"SSHException_subtitle2--invalid__w9PvX"};